module.exports = __webpack_public_path__ + "static/img_0697-56c4c78898b0583e5cdca9e6f1b17195.webp";